// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import useHttp from "hooks/use-http";

import { MdDelete, MdEdit } from "react-icons/md";

// material styles
import {
  Grid,
  IconButton,
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

// material icons
import { FilterAlt, Delete, Download } from "@mui/icons-material";

import { RiNumbersFill } from "react-icons/ri";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import DatePickerCM from "components/shared/DatePicker";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";
import DeleteModal from "components/shared/Modal/Delete";

// helper
import GenerateHeadCell from "helper/generate-head-cell";
import spliter from "helper/digit-spliter";
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledDateBox,
  StyledMenuItem,
  StyledGridIcons,
} from "./showExcellScores.style";

// request methods
import { getStudentScoresExcellByIdRequest } from "api/requests";

// constants
import { PAGINATION_LIMIT } from "constants";

import { useNavigate, useParams } from "react-router-dom";
import { convertNum } from "helper/convert-num";
import BackButton from "components/shared/BackButton";

// excell scores head cells
const headCells = GenerateHeadCell("excellScores_view_list_student");

export default function ShowExcellScores() {
  const { scores_excell_file_id } = useParams();
  const {
    register,
    control,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  // excellScores data state
  const [excellScoresData, setExcellScoresData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  const getScoresExcellFileData = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getStudentScoresExcellByIdRequest,
      values: { id: scores_excell_file_id },
    });
    if (res) {
      if (res.data.length < 1) {
        return setExcellScoresData({
          data: [{ content: "اطلاعات یافت نشد" }],
          count: 0,
        });
      }
      let transformedData = res?.data
        ?.filter((item) => item?.is_present == true)
        .map((item) => ({
          id: item.id,
          full_name: item?.score_model?.title ?? "ثبت نشده",
          score: item?.score ?? "غایب",
          raw_score: item?.raw_score ?? "غایب",
          rank: item?.rank ?? "غایب",
          correct: item?.correct ?? "غایب",
          not_ans: item?.not_ans ?? "غایب",
          wrong: item?.wrong ?? "غایب",
        }));
      setExcellScoresData({
        data: transformedData,
        count: transformedData.length,
      });
    }
    setLoading(false);
  }, []);
  useEffect(() => {
    getScoresExcellFileData();
  }, [page]);

  return (
    <DrawerCM title="مشاهده نمرات " $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          {/*<StyledStack>
             <Grid container>
              <Grid item sm={4} xs={12} p={0.5}>
                <TextField
                  label="جست و جو"
                  fullWidth
                  id="outlined-size-small"
                  size="small"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Grid>
              <Grid item sm={4} xs={12} p={0.5}>
                <Controller
                  control={control}
                  defaultValue={""}
                  name="select_educationalYear"
                  render={() => (
                    <FormControl fullWidth size="small">
                      <InputLabel id="select-educational-year">
                        انتخاب سال تحصیلی
                      </InputLabel>
                      <Select
                        id="educationalYear"
                        name="educationalYear"
                        label="انتخاب سال تحصیلی"
                        labelId="select-educational-year"
                        value={selectedEducationalYear?.value ?? ""}
                        {...register("educationalYear")}
                        error={Boolean(errors.educationalYear)}
                        helperText={errors.educationalYear?.message}
                        onChange={(e) =>
                          setSelectedEducationalYear({
                            value: e.target.value,
                          })
                        }
                      >
                        <StyledMenuItem value={"*"}>{"همه"}</StyledMenuItem>
                        {educationalYears.map((item, index) => {
                          return (
                            <StyledMenuItem key={index} value={item}>
                              {item + 1} - {item}
                            </StyledMenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item sm={4} xs={12} p={0.5}>
                <Controller
                  control={control}
                  defaultValue={""}
                  name="select_class"
                  render={() => (
                    <FormControl fullWidth size="small">
                      <InputLabel id="select-class">انتخاب کلاس</InputLabel>
                      <Select
                        id="class"
                        name="class"
                        label="انتخاب کلاس"
                        value={selectedClass ?? ""}
                        {...register("class_id")}
                        error={Boolean(errors.class_id)}
                        helperText={errors.class_id?.message}
                        onChange={(e) => setSelectedClass(e.target.value)}
                      >
                        {classesData?.data?.map((item, index) => (
                          <StyledMenuItem key={index} value={item.id}>
                            {item.title}
                          </StyledMenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item sm={5} xs={12} p={0.5}>
                <StyledDateBox>
                  <DatePickerCM
                    onChange={onFromDateHandler}
                    render={(value, openCalendar) => {
                      return (
                        <TextField
                          label="از تاریخ"
                          variant="outlined"
                          fullWidth
                          size="small"
                          id="from_created_at"
                          {...register("from_created_at")}
                          error={Boolean(errors.from_created_at)}
                          helperText={errors.from_created_at?.message}
                          value={fromDate ? fromDate.split("-").join("/") : ""}
                          onClick={openCalendar}
                        />
                      );
                    }}
                  />
                </StyledDateBox>
              </Grid>
              <Grid item sm={5} xs={12} p={0.5}>
                <StyledDateBox>
                  <DatePickerCM
                    onChange={onToDateHandler}
                    render={(value, openCalendar) => {
                      return (
                        <TextField
                          label="تا تاریخ"
                          variant="outlined"
                          fullWidth
                          size="small"
                          id="to_created_at"
                          {...register("to_created_at")}
                          error={Boolean(errors.to_created_at)}
                          helperText={errors.to_created_at?.message}
                          value={toDate ? toDate.split("-").join("/") : ""}
                          onClick={openCalendar}
                        />
                      );
                    }}
                  />
                </StyledDateBox>
              </Grid>
              <StyledGridIcons item sm={2} xs={12} p={0.5}>
                <IconButton color="primary" onClick={getExcellScoresList}>
                  <Tooltip title="اعمال فیلتر" placement="top">
                    <FilterAlt />
                  </Tooltip>
                </IconButton>
                <IconButton
                  color="error"
                  onClick={getExcellScoresListWithoutFiltered}
                >
                  <Tooltip title="حذف فیلتر" placement="top">
                    <Delete />
                  </Tooltip>
                </IconButton>
              </StyledGridIcons>
            </Grid> 
          </StyledStack>*/}
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/user_scores_excell-file" />
            </Grid>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست نمرات "
                rows={excellScoresData.data}
                headCells={headCells}
                page={page}
                colspan={excellScoresData.count === 0 ? "8" : ""}
                fontSize="14px"
                cellFontSize="14px"
              />
            </Grid>
            {excellScoresData.data.length < 1 ? (
              ""
            ) : (
              <Grid
                item
                xs={12}
                my={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <PaginationCM
                  handleChange={(_, val) => setPage(val)}
                  page={page}
                  count={excellScoresData.count}
                />
              </Grid>
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
